import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class AppConfigService {
    private appConfig: any;

    constructor() {

    }

    loadAppConfig() {
        let API, INTAPI, FININTAPI, CRMINTAPI;
        let FinanceIntegrationAPIScope, CRMIntegrationAPIScope
        if (String(environment.IS_APIM_ENDPOINT_ENABLED).toLowerCase() === 'true') {
            API = environment.API_URL_APIM;
            INTAPI = environment.INTEGRATION_API_URL_APIM;
        } else {
            API = environment.API_URL;
            INTAPI = environment.INTEGRATION_API_URL;
            FININTAPI = environment.FINANCE_INTEGRATION_API_URL;
            CRMINTAPI = environment.CRM_INTEGRATION_API_URL;
            FinanceIntegrationAPIScope = environment.Finance_Integration_api_scope
            CRMIntegrationAPIScope = environment.CRM_Integration_api_scope
        }
        this.appConfig = {
            DATA: {
                ENVIORNMENT: environment.ENVIRONMENT,
                GA_TRACKING_ID: environment.GA_TRACKING_ID,
                AMPLITUDE_API_KEY: environment.AMPLITUDE_API_KEY,
                ENGAGE_CALENDAR_JS_URL: environment.ENGAGE_CALENDAR_JS_URL,
                HOTDOCS_JS_URL: environment.HOTDOCS_JS_URL,
                OCP_APIM_SUBSCRIPTION_KEY: environment.OCP_APIM_SUBSCRIPTION_KEY,
                IS_APIM_ENDPOINT_ENABLED:environment.IS_APIM_ENDPOINT_ENABLED,
                LINE_OF_BUSINESS_ID_PS: environment.LINE_OF_BUSINESS_ID_PS,
                Version: environment.VERSION,
                API_END_POINT: {
                    API_URL: API,
                    INTEGRATION_API_URL: INTAPI,
                    FINANCE_INTEGRATION_API_URL: FININTAPI,
                    CRM_INTEGRATION_API_URL: CRMINTAPI
                },
                AZURE_AD_AUTHENTICATION: {
                    INSTANCE: environment.INSTANCE,
                    TENANT: environment.TENANT,
                    CLIENT_ID: environment.CLIENT_ID,
                    LOGIN_REDIRECT_URL: environment.LOGIN_REDIRECT_URL,
                    POST_LOGOUT_REDIRECT_URL: environment.POST_LOGOUT_REDIRECT_URL,
                    HOME_URL_WEB_API: environment.HOME_URL_WEB_API,
                    TOKEN_URL: environment.TOKEN_URL,
                    EXPIRE_OFFSET_SECONDS: environment.EXPIRE_OFFSET_SECONDS,
                    ADAL_LOGS: environment.ADAL_LOGS
                },
                ENGAGEMENT_ASSIGNMENT_ADMINISTRATOR_LIMIT: environment.ENGAGEMENT_ASSIGNMENT_ADMINISTRATOR_LIMIT,
                TEAM_MEMEBR_LIMIT: environment.TEAM_MEMBER_LIMIT,
                SHOW_CLOSE_BUTTON_RECORD_LIMIT: environment.SHOW_CLOSE_BUTTON_RECORD_LIMIT,
                API_SCOPE: {
                    FINANCE_INTEGRATION_APISCOPE: FinanceIntegrationAPIScope,
                    CRM_INTEGRATION_APISCOPE: CRMIntegrationAPIScope,
                    INTEGRATION_API_APISCOPE: environment.INTEGRATION_API_APISCOPE,
                    ENGAGE_API_APISCOPE: environment.ENGAGE_API_APISCOPE
                },
            },
            SP_EMAIL_PROVISION: {
                PRIMARY_ADMIN: environment.PRIMARY_ADMIN,
                PRIMARY_CONTACT: environment.PRIMARY_CONTACT,
                SECONDARY_CONTACT: environment.SECONDARY_CONTACT
            },
            CONTINUANCE_ELIGIBILITY_DATA: {
                SOLUTIONCODE: environment.CONTINUANCE_SOLUTIONCODE,
                HDTEMPLATEPACKAGEID: environment.CONTINUANCE_HDTEMPLATEPACKAGEID
            },
            ADD_MULTIPLE_DOCUMENT_LIMIT: environment.ADD_MULTIPLE_DOCUMENT_LIMIT,
            ADD_MULTIPLE_DOCUMENT_LIMIT_IWantTo: environment.ADD_MULTIPLE_DOCUMENT_LIMIT_IWantTo,
            ADV_029_DATA: {
                REALIZATION: environment.ADV_029_Realization_Value,
                ESTIMATED_GROSS_MARGIN: environment.ADV_029_Estimated_Cross_Margin,
                ESTIMATED_NET_FEES: environment.ADV_029_Estimated_Net_Fees
            },
        };

        return JSON.stringify(this.appConfig);

    }

    get config() {
        return this.appConfig;
    }
}
